import React from 'react';
import { Headphones, Briefcase, Heart, Building2, GraduationCap, Store, Users, Truck, Cloud, Shield } from 'lucide-react';

const IndustryFit = () => {
  const industries = [
    { icon: Shield, name: 'Defense & Government Operations', path: '/solutions/defense-government' },
    { icon: Headphones, name: 'Call & Contact Centers', path: '/solutions/call-centers' },
    { icon: Briefcase, name: 'Staffing & Workforce Services', path: '/solutions/staffing-recruiting' },
    { icon: Heart, name: 'Healthcare Organizations', path: '/solutions/healthcare' },
    { icon: Building2, name: 'Banks & Credit Unions', path: '/solutions/banks-credit-unions' },
    { icon: GraduationCap, name: 'Education (Staff & Operations)', path: '/solutions/education' },
    { icon: Store, name: 'Franchise & Multi-Unit Brands', path: '/solutions/franchise' },
    { icon: Truck, name: 'Logistics & Trucking', path: '/solutions/logistics-trucking' },
    { icon: Users, name: 'Consultants & Trainers (White Label)', path: '/solutions/consultants-trainers' },
    { icon: Cloud, name: 'Technology Platforms & Cloud Marketplaces', path: '/solutions/technology-platforms' }
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-transparent to-blue-950/20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            Built for <span className="text-cyan-400">Enterprise Reality</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-4xl mx-auto">
            Traain is used by organizations that need consistency, compliance, and performance across distributed teams.
          </p>
        </div>

        {/* First row - 5 items on desktop, 2 on tablet, 1 on mobile */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 sm:gap-6 max-w-7xl mx-auto mb-4 sm:mb-6">
          {industries.slice(0, 5).map((industry, index) => {
            const Icon = industry.icon;
            return (
              <a
                key={index}
                href={industry.path}
                className="p-4 sm:p-6 rounded-xl bg-gradient-to-br from-gray-900/80 to-blue-900/20 border border-cyan-500/30 hover:border-cyan-400/60 hover:shadow-lg hover:shadow-cyan-500/20 transition-all duration-300 text-center group"
              >
                <Icon className="w-8 sm:w-10 h-8 sm:h-10 text-cyan-400 mx-auto mb-3 sm:mb-4 group-hover:scale-110 transition-transform" />
                <p className="text-gray-300 group-hover:text-white transition-colors text-xs sm:text-sm">{industry.name}</p>
              </a>
            );
          })}
        </div>
        
        {/* Second row - 4 items centered */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 max-w-5xl mx-auto">
          {industries.slice(5).map((industry, index) => {
            const Icon = industry.icon;
            return (
              <a
                key={index + 5}
                href={industry.path}
                className="p-4 sm:p-6 rounded-xl bg-gradient-to-br from-gray-900/80 to-blue-900/20 border border-cyan-500/30 hover:border-cyan-400/60 hover:shadow-lg hover:shadow-cyan-500/20 transition-all duration-300 text-center group"
              >
                <Icon className="w-8 sm:w-10 h-8 sm:h-10 text-cyan-400 mx-auto mb-3 sm:mb-4 group-hover:scale-110 transition-transform" />
                <p className="text-gray-300 group-hover:text-white transition-colors text-xs sm:text-sm">{industry.name}</p>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default IndustryFit;
